const translations = {
  "en": {
    "Best reply": "Best reply",
    "Copied": "Copied",
    "Copy": "Copy",
    "Dislike": "Dislike",
    "Regenerate": "Regenerate",
    "Share": "Share"
  },
  "zh-tw": {
    "Best reply": "最佳回覆",
    "Copied": "已複製",
    "Copy": "複製",
    "Dislike": "不喜歡",
    "Regenerate": "重新生成",
    "Share": "分享"
  }
};

export default translations;
